import { render, staticRenderFns } from "./request-ip.vue?vue&type=template&id=8a591c50"
import script from "./request-ip.vue?vue&type=script&lang=js"
export * from "./request-ip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports